














    import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import AlbumListItem from "../../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/PhotoGalleryModels/AlbumListItem";
@Component
    export default class GalleryPreviewComponent extends Vue{
        @Prop()
        album: AlbumListItem;
    }
